import { HttpClient } from '@angular/common/http';
import { Directive, Injectable, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GoogleObj, GoogleTranslateResponse } from '../_models/models';
import { SettingsProvider } from './settingsProvider.service';

@Directive()
@Injectable()
export class GoogleTranslateService {


  constructor(private http: HttpClient,  private router: Router) {
  }


  translate(theModel: GoogleObj): Observable<GoogleTranslateResponse> {
       return this.http.post<GoogleTranslateResponse>(`https://translation.googleapis.com/language/translate/v2?key=AIzaSyA-ythcccJbdL0DoCZ1KV8jFnblSLx0G0U`, theModel)
            .pipe(map((result: GoogleTranslateResponse) => result));
  }
}
